export default "__VITE_ASSET__BgU0EbEP__"